import React from 'react';
import { Header } from '../Header';
import { Navigation } from '../Navigation';
import { Footer } from '../Footer';
import styles from '../../utils/styles/components/MainLayout/style.module.css';

export const MainLayout = ({
  eyebrow,
  title,
  subtitle,
  navItems,
  children,
  frameDevice = null,
  immersiveMode = false,
  showHeader = true,
  showNavigation = true,
  showFooter = true,
  previewDevice = 'desktop',
  previewMode = false
}) => {
  const frameClassName = (frameDevice === 'mobile' || (previewMode && previewDevice === 'mobile'))
    ? `${styles.frame} ${styles.previewFrameMobile}`
    : styles.frame;
  const mainClassName = previewMode
    ? `${styles.main} ${styles.previewMain}`
    : immersiveMode
      ? `${styles.main} ${styles.immersiveMain}`
      : styles.main;

  return (
    <div className={styles.layout}>
      {showNavigation ? <Navigation items={navItems} /> : null}
      <main className={mainClassName}>
        <div className={frameClassName}>
          {showHeader ? <Header eyebrow={eyebrow} title={title} subtitle={subtitle} /> : null}
          {children}
        </div>
      </main>
      {showFooter ? <Footer /> : null}
    </div>
  );
};
